module.exports = __webpack_public_path__ + "static/media/rosalina_0.e8d1310d.png";